var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.value)?_c('AdminBadge',{attrs:{"color":_vm.meta.color,"icon":_vm.meta.icon,"min-width":104}},[_vm._v(" "+_vm._s(_vm.meta.label)+" ")]):_c('span',{staticClass:"text-grey-6"},[_vm._v("—")])
}
var staticRenderFns = []

export { render, staticRenderFns }